import en from './en';
import hy from './hy';
import ru from './ru';

export default { en, ru, hy };
